import React, { useEffect, useState } from "react";
import "./LoanLangTagsTable.scss";
import { Box, Typography, Button } from "@mui/material";
import LoanSetupTable from "../LoanSetupTable/LoanSetupTable";
import { commonRunQuery, loansCreateLanguageTag, loansUpdateLangTag } from "../../util/API/loans";
import CustomLoansForm from "../UI/CustomLoansForm/CustomLoansForm";
import { useDispatch } from "react-redux";
import { setNewConstants } from "../../store/redux/constants";

const LoanLangTagsTable = ({ langIdTableData, setViewMode, setValue, setAlert, fromTab, selectedLangId, setAlertOpen }) => {
    const [langTagsData, setLangTagsData] = useState([]);
    const [viewLangTagsMode, setViewLangTagsMode] = useState("table");
    const [formValues, setFormValues] = useState(null);
    const [langTagLanguages, setLangTagLanguages] = useState([]);
    const [langTagId, setLangTagId] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    
    const dispatch = useDispatch();

    // useEffect(()=> {
    //     console.log("useEffect_langIdTableData-------------",langIdTableData);
    //     if(langIdTableData) {
    //         setLangTagsData(langIdTableData);
    //         getAllLanguages();
    //     } else {
    //         getAllLangIds();
    //         getAllLanguages();
    //     }
    // },[langIdTableData]);

    useEffect(()=> {
        console.log("useEffect_langIdTableData-------------",langIdTableData);
        if(langIdTableData) {
            getSpecificLangId();
            // setLangTagsData(langIdTableData);
            getAllLanguages();
        } else {
            getAllLangIds();
            getAllLanguages();
        }
    },[selectedLangId]);

    useEffect(()=> {
        if(viewLangTagsMode == "create" || viewLangTagsMode == "edit") {
            console.log("useEffect_langTagLanguagessssssssssss-------------",langTagLanguages);
            dispatch(setNewConstants({ formSelectData: { langID: langTagLanguages } }));
        }
    },[viewLangTagsMode, langTagLanguages])

    const getAllLangIds = async() => {
        try {
            const response = await commonRunQuery(276, "");
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const langIdDataArray = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];
                    setLangTagsData(langIdDataArray);
                console.log("langIdDataArray=======================",langIdDataArray);
            } else {
                setLangTagsData([]);
            }
        } catch (error) {
            console.log("getAllLangIds_error=======================",error);
        }
    }

    const getSpecificLangId = async() => {
        try {
            const response = await commonRunQuery(275,selectedLangId);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const langIdDataArray = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];
                    setLangTagsData(langIdDataArray);
                console.log("getSpecificLangId=======================",langIdDataArray);
            } else {
                setLangTagsData([]);
            }
        } catch (error) {
            console.log("getSpecificLangId_error=======================",error);
        }
    }

    const getAllLanguages = async () => {
        try {
            let response = await commonRunQuery(277, "");
            if (
                response?.data?.header?.callStatus === "1" &&
                response?.data?.header?.reccount !== "0"
            ) {
                const languagesArray = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];
    
                const formattedLanguages = languagesArray.map(item => ({
                    key: item.lang.langID,
                    value: item.lang.langID,
                    label: item.lang.langID,
                }));
    
                setLangTagLanguages(formattedLanguages);
                console.log("formattedLanguages=======================", formattedLanguages);
            } else {
                setLangTagLanguages([]);
            }
        } catch (error) {
            console.log("getAllCategories_error=======================", error);
        }
    };

    const columns = [
        {
            label: 'Language',
            getValue: (row) => row?.langtag?.langID ?? ''
        },
        {
            label: 'TagID',
            getValue: (row) => row?.langtag?.tagID ?? ''
        },
        {
            label: 'Label',
            getValue: (row) => row?.langtag?.label?.toString().trim() ? row?.langtag?.label : "-",
            style: { maxWidth: 200 }
        },
    ];

    const handleLangTagCreate = async(submittedValue) => {
        try {
            const response = await loansCreateLanguageTag("", submittedValue?.langID, langTagId, submittedValue?.label);

            console.log("handleLangTagCreate_res----------------", response)
            
            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Lang Tag created successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);

                if(selectedLangId) {
                    getSpecificLangId();
                } else {
                    getAllLangIds();
                }
                setLangTagId(null);
                setViewLangTagsMode("table");
            } else if(response?.Status == '2' && response?.payload?.callStatus == "0") {
                setAlert({
                    showAlert: true,
                    message: response?.payload?.msg,
                    severity: "error",
                    header: "Error",
                });
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in creating lang tag. " + error,
                severity: "error",
                header: "Error",
            });
        }
    }

    const handleLangTagEdit = async(submittedValue) => {
        try {
            // const currentTagID = langTagId;
            // const submittedLangID = submittedValue.langID;

            // // Exclude the current editing row (selectedData)
            // const isDuplicate = langTagsData.some(item =>
            //     item.langtag.tagID === currentTagID &&
            //     item.langtag.langID === submittedLangID &&
            //     !(item.langtag.tagID === selectedData.tagID &&
            //         item.langtag.langID === selectedData.langID)
            // );

            // if (isDuplicate) {
            //     setAlert({
            //         showAlert: true,
            //         message: "This language already exists for this tag.",
            //         severity: "error",
            //         header: "Error",
            //     });
            //     return;
            // }

            const response = await loansUpdateLangTag("", submittedValue?.tagID, submittedValue?.langID, submittedValue?.label);

            console.log("handleLangTagEdit_res----------------", response)
            
            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Lang Tag updated successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);
                
                if(selectedLangId) {
                    getSpecificLangId();
                } else {
                    getAllLangIds();
                }
                setViewLangTagsMode("table");
                setSelectedData(null);
            } else if(response?.Status == '2' && response?.payload?.callStatus == "0") {
                setAlert({
                    showAlert: true,
                    message: response?.payload?.msg,
                    severity: "error",
                    header: "Error",
                });
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in updating lang tag. " + error,
                severity: "error",
                header: "Error",
            });
        }
    }

    // const handleAddLangTag = async(rowData) => {
    //     const updatedLangTagLanguages = langTagLanguages.filter(
    //         lang => lang.key !== rowData?.langtag?.langID
    //     );
    //     console.log("rowData---------------------",rowData);
    //     console.log("langTagsData---------------------",langTagsData);
    //     console.log("langTagLanguages---------------------",langTagLanguages);
    //     console.log("updatedLangTagLanguages---------------------",updatedLangTagLanguages);
    //     setLangTagLanguages(updatedLangTagLanguages)
    //     setLangTagId(rowData?.langtag?.tagID);
    //     setViewLangTagsMode("create")
    // }

    const handleAddLangTag = async (rowData) => {
        const selectedTagID = rowData?.langtag?.tagID;
    
        // Filter all entries that have the same tagID
        const matchingLangTags = langTagsData.filter(item => item.langtag?.tagID === selectedTagID);
    
        // Get all langIDs that already exist for this tagID
        const existingLangIDs = matchingLangTags.map(item => item.langtag?.langID);
    
        // Filter langTagLanguages to only keep the ones not already used for this tagID
        const availableLanguages = langTagLanguages.filter(lang => !existingLangIDs.includes(lang.key));
    
        console.log("availableLanguages---------------------", availableLanguages);
    
        setLangTagLanguages(availableLanguages);
        setLangTagId(selectedTagID);
        setViewLangTagsMode("create");
    }

    const handleEdit = async(rowData) => {
        console.log("handleEdit----------------",rowData);
        await getAllLanguages();
        setLangTagId(rowData?.langtag?.tagID);
        setViewLangTagsMode("edit");
        setSelectedData({
            langID: rowData?.langtag?.langID,
            label: rowData?.langtag?.label,
            tagID: rowData?.langtag?.tagID
        })
        console.log("handleEdit_langTagLanguages----------------",langTagLanguages)
        console.log("handleEdit_selData----------------",langIdTableData)

        // dispatch(setNewConstants({ formSelectData: { langID: langTagLanguages } }));
    }

    return (
        <Box>

            <Box className="d-flex justify-content-between mb-2">
                <Typography
                        sx={{
                            fontFamily: "'Nunito'",
                            fontStyle: "normal",
                            fontWeight: 500,
                            fontSize: "21.4825px",
                            color: "#3A3A3A",
                        }}
                    >
                        
                </Typography>

                {
                    !langIdTableData && 
                    <Box className="d-flex gap-2">
                        {
                            viewLangTagsMode == "table" && 
                            <Button
                                className="fs-size-12 paiy-blue text-white"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    setViewLangTagsMode("create")
                                    getAllLanguages();
                                }}
                            >
                                Create Lang Tag
                            </Button>
                        }
                        {
                            viewLangTagsMode !== "table" && 
                            <Button
                                className="fs-size-12 paiy-blue text-white"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    setViewLangTagsMode("table")
                                }}
                            >
                                Return
                            </Button>
                        }
                    </Box>
                }

                {
                    langIdTableData &&
                    <Box className="d-flex gap-2">
                        <Button
                            className="fs-size-12 paiy-blue text-white"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                if(fromTab == "LoanCurrMessages") {
                                    setValue(6);
                                } else if(fromTab == "LoanLanguages") {
                                    setViewMode("table")
                                    setValue(4);
                                }else {
                                    setViewMode("view")
                                    setValue(2);
                                }
                            }}
                        >
                            Return
                        </Button>
                    </Box>
                }
            </Box>

            {
                viewLangTagsMode === "create" || viewLangTagsMode === "edit"  ? (
                    <Box sx={{ width:"40%"}}>
                        <CustomLoansForm
                            formValues={formValues}
                            formName={"createlangtags"}
                            buttonText={"Submit"}
                            onSubmit={viewLangTagsMode == "create" ? handleLangTagCreate : handleLangTagEdit}
                            loadingButtonText={"Creating Loan Type ..."}
                            isCreate={viewLangTagsMode === "create" ? true : false}
                            isEdit={viewLangTagsMode === "edit" ? true : false}
                            initialValues={selectedData}
                        />
                    </Box>
                ) : (
                    <LoanSetupTable
                        data={langTagsData}
                        columns={columns}
                        title="Loan Types"
                        formatRow={(row) => [
                            row?.loantypes?.loantype,
                            row?.loantypes?.loandesc,
                            row?.loantypes?.flagging,
                            row?.loantypes?.flaggingdays,
                            row?.loantypes?.optin,
                            row?.loancategories?.isflaggedloandue
                        ]}
                        addLangTag={true}
                        handleAddLangTag={handleAddLangTag}
                        isEdit={true}
                        handleEdit={handleEdit}
                        // handleViewDetails={handleViewDetails}
                        // viewDetails={true}
                    />
                )
            }
        </Box>
    )
}

export default LoanLangTagsTable;
